import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Box, Typography } from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../utils/constants';

interface Codebase {
  pk: string;
  sk: string;
  cf_stack_name: string | null;
  cf_stack_status: string | null;
  frontend_artifact_status: string;
  code_s3_bucket_name: string;
  code_s3_prefix: string;
  deployment_state: string;
}

export const CodeBases: React.FC = () => {
  const [codebases, setCodebases] = useState<Codebase[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCodebases = async () => {
      try {
        const response = await axios.get(`${API_URL}/codebases`);
        setCodebases(response.data.items);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching codebases:', error);
        setLoading(false);
      }
    };

    fetchCodebases();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: '20px', paddingTop: '40px', paddingBottom: '20px', borderRadius: '8px' }}>
      <Typography variant="h3" sx={{ marginBottom: '40px', color: '#333', textAlign: 'center' }}>Codebases</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S3 Bucket Name</TableCell>
              <TableCell>S3 Prefix</TableCell>
              <TableCell>CloudFormation Stack Name</TableCell>
              <TableCell>CloudFormation Stack Status</TableCell>
              <TableCell>Frontend Artifact Status</TableCell>
              <TableCell>Deployment State</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {codebases.map((codebase) => (
              <TableRow key={codebase.pk}>
                <TableCell>{codebase.code_s3_bucket_name}</TableCell>
                <TableCell>{codebase.code_s3_prefix}</TableCell>
                <TableCell>{codebase.cf_stack_name || 'N/A'}</TableCell>
                <TableCell>{codebase.cf_stack_status || 'N/A'}</TableCell>
                <TableCell>{codebase.frontend_artifact_status}</TableCell>
                <TableCell>{codebase.deployment_state}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CodeBases;